<template>
  <!-- <div class="container">
    <div class="qr">
      <p>扫描二维码，邀请店员</p>
      <vue-qr :logoSrc="imageUrl" text="123456789" :size="200"></vue-qr>
    </div>
  </div>-->
  <div class="container">
    <!-- <button @click="test">跳下一页</button> -->
    <div class="qr" v-show="isShow">
      <img :src="imageUrl" alt />
    </div>
    <div v-show="!isShow" style="padding-top:30vw">
      <van-empty image="network" description="什么都没有哦" />
    </div>
  </div>
</template>
<script>
// import vueQr from "vue-qr";
import { Toast, Dialog, Empty } from "vant";
import { mapGetters } from "vuex";
export default {
  name: "qecode",
  data() {
    return {
      shareCode: "",
      imageUrl: "",
      isShow: false
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Empty.name]: Empty
    // vueQr
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (this.userInfo.shareCodeImageUrl == '') {
        this.isShow = false;
      } else {
        this.imageUrl = this.userInfo.shareCodeImageUrl;
        this.isShow = true;
      }
    },
    // test() {
    //   if (this.userInfo.isEmployee) {
    //     this.shareCode = this.userInfo.employee.shareCode;
    //     return;
    //   }
    //   if (this.userInfo.isOwner) {
    //     this.shareCode = this.userInfo.ownerInfo.shareCode;
    //     return;
    //   }
    // var shareCode = "66666666"
    //   this.$router.replace({ 
    //     name: "clerkRegister",
    //     query: { shareCode: shareCode }
    //   });
    // }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
// .container {
//   background: #f7f7f7;
//   height: 100%;
//   padding: 30px 23px;
//   .qr {
//     padding: 34px 0;
//     background: #fff;
//     text-align: center;
//     p {
//       margin: 0;
//     }
//   }
// }
.container {
  width: 100%;
  height: calc(100% - 12.3vw);
  background: #fff;
  .qr {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .custom-image .van-empty__image {
    width: 36vw;
    height: 36vw;
  }
}
</style>